module.exports = __webpack_public_path__ + "assets/img/Header_bg.b721a4a5.png";